import { IPartnerParams } from '@/partners/partnerTypes';
import { EParameters } from '@/utils/setParametersFromParams';

import { getCaseInsensitiveParam } from '../getCaseInsensitiveParam';

import { ISetInitialLoan } from './ISetInitialLoan';

export function getInitialLoanData(
    partner: IPartnerParams,
    params: URLSearchParams
): ISetInitialLoan {
    // loanPurpose is the DS API external field (for Dutton), loanUsage is internal
    // Support both: loanPurpose takes priority for DS API integrations
    const loanUsageValue =
        getCaseInsensitiveParam(params, EParameters.LOAN_PURPOSE) ||
        getCaseInsensitiveParam(params, EParameters.LOAN_USAGE);

    const parameterLoanTerm = getCaseInsensitiveParam(
        params,
        EParameters.LOAN_TERM
    );

    return {
        partnerLoanUsage: partner.loanUsage,
        parameterLoanUsage: loanUsageValue,
        partnerLoanType: partner.initialLoanType,
        partnerLoanTerm: partner.loanTerm,
        parameterLoanTerm,
        parameterDepositAmount: getCaseInsensitiveParam(
            params,
            EParameters.DEPOSIT_AMOUNT
        ),
        parameterTradeInAmount: getCaseInsensitiveParam(
            params,
            EParameters.TRADE_IN_AMOUNT
        ),
        parameterBalloonPercentage: getCaseInsensitiveParam(
            params,
            EParameters.BALLOON_PERCENTAGE
        ),
    };
}
